<template>
	<b-modal
		size="lg"
		id="modal-notification"
		centered
		title="Notification"
		hide-footer
		@show="onModalShow"
		@hide="closeNotification"
		@submitApproveDisapprove="submitApproveDisapprove"
	>
		<div class="notification-content mt-2" v-show="submitLoading">
			<div class="d-flex justify-content-center">
				<b-spinner variant="primary" label="Spinning"></b-spinner>
				<span class="ml-2">Sending notification, please wait...</span>
			</div>
		</div>
		<div class="notification-content mt-2" v-show="!submitLoading">
			<div class="card p-3">
				<div class="row">
					<div class="col-12 col-md-6">
						<label for="email-to">Recipients</label>
						<v-select
							ref="ref_emails"
							v-model="payload.emails"
							placeholder="Type email then press enter to add"
							multiple
							taggable
							no-drop
							:select-on-key-codes="[188, 13]"
							:select-on-tab="true"
							@search:blur="addEmail('emails')"
							:disabled="isSendtoAllDepartment"
						></v-select>
						<div class="d-flex">
							<div class="form-check" v-if="type == 'reminder'">
								<input class="form-check-input" type="checkbox" v-model="isSendtoAllDepartment" id="send-all-department" />
								<label class="form-check-label" for="send-all-department"> Send to all department </label>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6">
						<label for="email-to">Email Cc</label>
						<v-select
							ref="ref_emailCc"
							v-model="payload.emailCc"
							placeholder="Type email then press enter to add"
							multiple
							taggable
							no-drop
							:select-on-key-codes="[188, 13]"
							:select-on-tab="true"
							@search:blur="addEmail('emailCc')"
						></v-select>
					</div>
				</div>
			</div>
			<div class="card p-3 hidden" v-show="type != 'approve' && type != 'disapprove'">
				<div class="row">
					<div class="col-12 mt-2">
						<label for="email-to">Attachments</label>
						<input type="file" class="form-control" ref="file_attachments" multiple @change="setFileAttachments" />
					</div>
					<div class="col-12 mt-2" v-if="uploading == true">
						<b-skeleton animation="wave" :width="`${uploadingProgress}%`"></b-skeleton>
					</div>
					<div class="col-12 mt-2" v-if="payload.attachments.length > 0 && uploading == false">
						<template v-for="(uploaded, index) in payload.attachments">
							<a class="btn btn-link" :href="uploaded.url" target="_blank">{{ uploaded.filename }}</a>
						</template>
					</div>
				</div>
			</div>
			<div class="card p-3 hidden" v-show="type != 'approve' && type != 'disapprove'">
				<div class="row">
					<div class="col-12 mt-2">
						<div class="form-group">
							<label>Email Body <span class="text-danger">*</span></label>
							<vue-editor v-model="payload.message" v-validate="'required'" name="Email Body" />
							<span class="text-sm text-danger" v-show="errors.has('Email Body')">{{ errors.first('Email Body') }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-end" v-if="!submitLoading">
			<button class="btn btn-outline-secondary" @click="closeConfirmModal">Cancel</button>
			<button class="btn btn-primary ml-2" @click="sendConfirmation" :disabled="submitLoading">{{ btnSendLabel }}</button>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: 'ModalNotification',
	props: { department: String, listDepartment: Array, type: String, recipients: Array, plan: Object, reason: String },
	data() {
		return {
			payload: {
				emailCc: [],
				emails: [],
				attachments: [],
				message: '',
				department: '',
				type: '',
				plan: null,
				reason: '',
			},
			defaultEmails: [
				'yusak-putra@borneo-indobara.com',
				'aditya.putra@sinarmasmining.com',
				'muhammad.krismansyah@borneo-indobara.com',
				'puji-ambarwati@sinarmasmining.com',
			],
			uploading: false,
			uploadingProgress: 0,
			submitLoading: false,
			isSendtoAllDepartment: false,
		};
	},
	computed: {
		selectedDepartment() {
			if (this.isSendtoAllDepartment) return 'All Departments';
			return this.listDepartment.filter((item) => item.value == this.department)?.[0]?.row.department_name;
		},
		btnSendLabel() {
			switch (this.type) {
				case 'reminder':
					return 'Send Reminder';
					break;
				case 'respond':
					return 'Send Respond';
					break;
				case 'approve':
					return 'Approve';
					break;
				case 'disapprove':
					return 'Disapprove';
					break;
				default:
					return 'Send';
					break;
			}
		},
		templateMessage() {
			switch (this.type) {
				case 'reminder':
					return `<p>Dear [fullname],</p><p>Sehubungan dengan pembuatan budget [next_year], terlampir schedule, asumsi dan template budget [year]. Mohon draft budget dapat dikirimkan maksimal di minggu ketiga bulan September [year].</p><br><p>Regards</p><p>[me]</p>`;
					break;
				case 'respond':
					return `<p>Dear Tim Budget,</p><p>Terlampir Draft Budget [department] [next_year].</p><p>Terima kasih.</p><br><p>Regards,</p>[me]</p><p>[department]</p>`;
				case 'request_approval':
					return `
						<p>Yth. Tim Budget,</p>
						<p>Dengan email ini kami mengajukan <b>permohonan approval Budget Plan</b> untuk Department <b>[department]</b>.</p>
						<br>
						<p>Detail Budget Plan:</p>
						<p><b>Department</b> : [department]</p>
						<p><b>Nama Budget Plan</b> : [plan_title]</p>
						<p><b>Version</b> : [plan_version]</p>
						<p><b>Periode</b> : [plan_year]</p>
						<p><b>Total Budget</b> : [total_budget]</p>
						<p><b>Tanggal Pengajuan</b> : [request_date]</p>
						<p><b>Diajukan oleh</b> : [me]</p>
						<br>
						<p>Mohon bantuan Tim Budget untuk melakukan <b>review dan approval</b> terhadap budget plan tersebut melalui sistem <b>uBudget</b>.</p>
						<p>Apabila terdapat hal yang perlu diklarifikasi atau dilengkapi, kami siap untuk menindaklanjuti.</p>
						<p>Atas perhatian dan kerja samanya, kami ucapkan terima kasih.</p>
						<p>Hormat kami,</p>
						<p>[department]</p>
						<p>[me]</p>
						`
						.replace(/\n/g, '')
						.replace(/\s+/g, ' ')
						.trim();
				case 'request_clone':
					return `
						<p>Yth. Tim Budget,</p>
						<p>Dengan email ini kami mengajukan <b>permohonan Clone/Duplikat Budget Plan</b> ke versi selanjutnya untuk Department <b>[department]</b>.</p>
						<br>
						<p>Detail Budget Plan:</p>
						<p><b>Department</b> : [department]</p>
						<p><b>Nama Budget Plan</b> : [plan_title]</p>
						<p><b>Version</b> : [plan_version]</p>
						<p><b>Periode</b> : [plan_year]</p>
						<p><b>Total Budget</b> : [total_budget]</p>
						<p><b>Tanggal Pengajuan</b> : [request_date]</p>
						<p><b>Diajukan oleh</b> : [me]</p>
						<p><b>Link</b> : [link]</p>
						<br>
						<p>Mohon bantuan Tim Budget untuk melakukan <b>review dan clone</b> terhadap budget plan tersebut melalui sistem uBudget.</p>
						<p>Apabila terdapat hal yang perlu diklarifikasi atau dilengkapi, kami siap untuk menindaklanjuti.</p>
						<p>Atas perhatian dan kerja samanya, kami ucapkan terima kasih.</p>
						<p>Hormat kami,</p>
						<p>[department]</p>
						<p>[me]</p>
						`
						.replace(/\n/g, '')
						.replace(/\s+/g, ' ')
						.trim();
				case 'approve':
					return `
						<p>Yth. Bapak/Ibu Tim <b>[department],</b></p>
						<p>Dengan ini kami informasikan bahwa Budget Plan untuk Department <b>[department]</b> telah <b>DISETUJUI (APPROVED)</b> oleh <b>Tim Budget</b>.</p>
						<br>
						<p>Berikut detail informasi Budget Plan:</p>
						<p><b>Nama Department</b> : [department]</p>
						<p><b>Periode Budget</b> : [plan_year]</p>
						<p><b>Nomor / Kode Budget Plan</b> : [plan_title] versi [plan_version]</p>
						<p><b>Tanggal Approval</b> : [request_date]</p>
						<p><b>Disetujui oleh</b> : [me]</p>
						<p><b>Link Ke Budget Plan</b> : [link]</p>
						<p>Silakan melanjutkan proses sesuai dengan ketentuan dan kebijakan yang berlaku.</p>
						<br>
						<p>Apabila diperlukan penyesuaian atau informasi tambahan, dapat dikoordinasikan lebih lanjut dengan <b>Tim Budget</b>.</p>
						<p>Demikian informasi ini kami sampaikan.</p>
						<p>Atas perhatian dan kerja samanya, kami ucapkan terima kasih.</p>
						<br>
						<p>Hormat kami,</p>
						<p><b>Tim UBudget</b></p>
					`
						.replace(/\n/g, '')
						.replace(/\s+/g, ' ')
						.trim();
				case 'disapprove':
					return `
						<p>Yth. Bapak/Ibu Tim <b>[department],</b></p>
						<p>Dengan ini kami informasikan bahwa Budget Plan untuk Department <b>[department]</b> telah <b>DITOLAK (DISAPPROVED)</b> oleh <b>Tim Budget</b>.</p>
						<br>
						<p>Berikut detail informasi Budget Plan:</p>
						<p><b>Nama Department</b> : [department]</p>
						<p><b>Periode Budget</b> : [plan_year]</p>
						<p><b>Nomor / Kode Budget Plan</b> : [plan_title] versi [plan_version]</p>
						<p><b>Tanggal Disapproval</b> : [request_date]</p>
						<p><b>Ditolak oleh</b> : [me]</p>
						<br>
						<p><b>Alasan Penolakan</b> :</p>
						<p>[reason]</p>
						<br>
						<p>Demikian informasi ini kami sampaikan.</p>
						<p>Atas perhatian dan kerja samanya, kami ucapkan terima kasih.</p>
						<br>
						<p>Hormat kami,</p>
						<p><b>Tim UBudget</b></p>
					`
						.replace(/\n/g, '')
						.replace(/\s+/g, ' ')
						.trim();
				default:
					return '';
					break;
			}
		},
	},
	watch: {
		isSendtoAllDepartment(val) {
			this.resetPayload();
			if (val) {
				this.onModalShow();
				this.payload.emails = 'All Departments';
				this.payload.emailCc = this.defaultEmails;
			} else {
				this.onModalShow();
			}
		},
	},
	methods: {
		addEmail(input) {
			if (input == 'emails') {
				let inputValue = this.$refs.ref_emails.search;
				if (inputValue && !this.payload.emails.includes(inputValue)) {
					this.payload.emails.push(inputValue);
				}
				this.$refs.ref_emails.search = '';
			} else {
				let inputValue = this.$refs.ref_emailCc.search;
				if (inputValue && !this.payload.emailCc.includes(inputValue)) {
					this.payload.emailCc.push(inputValue);
				}
				this.$refs.ref_emailCc.search = '';
			}
		},
		validateAttachments(event) {
			const files = event.target.files;
			const maxSize = 10 * 1024 * 1024;
			const allowedTypes = [
				'application/pdf',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/msword',
				'application/vnd.ms-excel',
			];

			if (files.length < 1) return false;

			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				if (file && file.size > maxSize) {
					this.$swal({
						title: 'Error',
						text: 'File size exceeds 10MB. Please upload a smaller file.',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					event.target.value = '';
					return;
				}
				if (file && !allowedTypes.includes(file.type)) {
					this.$swal({
						title: 'Error',
						text: 'Only PDF, DOCX, XLSX, DOC, XLS files are allowed.',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					event.target.value = '';
					return;
				}
			}
			return true;
		},

		async setFileAttachments(event) {
			const validate = this.validateAttachments(event);
			if (!validate) return;

			const payload = {
				department: this.selectedDepartment,
				attachments: [...event.target.files],
			};

			this.uploading = true;

			// animate loading progress
			let progress = 0;
			const duration = 3000;
			const start = performance.now();
			const interval = setInterval(() => {
				const timeElapsed = performance.now() - start;
				const progress = Math.min((timeElapsed / duration) * 100, 100);
				this.uploadingProgress = progress;
				if (progress >= 100) clearInterval(interval);
			}, 10);
			await this.uploadFiles(payload).finally(() => {
				this.uploading = false;
				this.uploadingProgress = 0;
			});
		},

		async uploadFiles(payload) {
			console.log('-files-', payload);
			try {
				const uploadedFiles = await this.$store.dispatch('budgetPlan/UPLOAD_DOCUMENT', payload);
				this.payload.attachments = uploadedFiles;
			} catch (error) {
				console.error(error);
				this.$swal({
					title: 'Error',
					text: 'An error occurred while uploading files.',
					icon: 'error',
					confirmButtonText: 'OK',
				});
			}
		},

		async setRecipients() {
			switch (this.type) {
				case 'reminder':
					this.payload.emails = this.recipients;
					this.payload.emailCc = this.defaultEmails;
					break;
				case 'request_approval':
					this.payload.emails = this.defaultEmails;
					this.payload.emailCc = [];
					break;
				case 'request_clone':
					this.payload.emails = this.defaultEmails;
					this.payload.emailCc = [];
					break;
				case 'respond':
					this.payload.emailCc = this.recipients;
					this.payload.emails = this.defaultEmails;
					break;
				case 'approve':
					this.payload.emailCc = this.defaultEmails;
					this.payload.emails = this.recipients;
					break;
				case 'disapprove':
					this.payload.emailCc = this.defaultEmails;
					this.payload.emails = this.recipients;
					break;
				default:
					this.payload.emails = [];
					this.payload.emailCc = [];
					break;
			}
		},

		onModalShow() {
			this.payload.message = this.templateMessage;
			this.payload.department = this.selectedDepartment || this.department;
			this.payload.type = this.type;
			if (this.plan) {
				this.payload.plan = this.plan;
			}
			if (this.reason) {
				this.payload.reason = this.reason;
			}
			this.setRecipients();
			console.log('modalPayload', this.payload);
			console.log('listDepartment', this.listDepartment);
			console.log('selectedDepartment', this.selectedDepartment);
		},

		closeNotification(evt) {
			if (evt.trigger === 'backdrop') {
				evt.preventDefault();
			}
			if (evt.trigger === 'headerclose') {
				evt.preventDefault();
				this.closeConfirmModal();
			}
		},

		resetPayload() {
			this.payload = {
				emailCc: [],
				emails: [],
				attachments: [],
				message: '',
				department: '',
				plan: null,
				type: '',
				reason: '',
			};
			this.uploadedFiles = [];
			this.$refs.file_attachments.value = null;
		},

		closeConfirmModal(evt) {
			this.$swal({
				title: 'Are you sure ?',
				text: 'This notification will be canceled',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: `Yes, i'm sure!`,
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.isConfirmed) {
					this.resetPayload();
					this.$emit('hide-modal');
				}
			});
		},

		sendConfirmation() {
			const sendingNotification = async () => {
				const payload = this.payload;
				const successDepartments = [];
				const errorDepartments = [];
				if (this.isSendtoAllDepartment) {
					const emailCc = payload.emailCc;
					//send notification to each department recipients
					for (const department of this.listDepartment) {
						try {
							const emails = await this.getUserEmailByDepartment(department.value);
							payload.emails = [...emails];
							payload.emailCc = [];
							payload.department = department.row.department_name;
							console.log(payload);
							await this.$store.dispatch('budgetPlan/SEND_NOTIFICATION', payload);
							successDepartments.push('successDepartments', payload.deparment);
						} catch (error) {
							console.error('Error sending notification:', error);
							errorDepartments.push(payload.deparment);
						}
						await new Promise((resolve) => setTimeout(resolve, 100));
					}

					//send notification to default recipients
					try {
						payload.emails = [];
						payload.emailCc = emailCc;
						payload.department = 'All Departments';
						console.log(payload);
						await this.$store.dispatch('budgetPlan/SEND_NOTIFICATION', payload);
						successDepartments.push('successDepartments', payload.deparment);
					} catch (error) {
						console.error('Error sending notification:', error);
						errorDepartments.push(payload.deparment);
					}
					console.log('errorDepartments', errorDepartments);
				} else {
					console.log(payload);

					await this.$store.dispatch('budgetPlan/SEND_NOTIFICATION', payload);
					if (this.type == 'approve' || this.type == 'disapprove') {
						await this.submitApproveDisapprove();
					}
				}
			};

			this.$swal({
				title: 'Are you sure ?',
				text: 'Notification will be sent to all recipients added',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: `Yes, i'm sure!`,
				cancelButtonText: 'Cancel',
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						this.submitLoading = true;
						await sendingNotification().then(async () => {
							this.resetPayload();
							this.isSendtoAllDepartment = false;
							this.$swal({
								title: 'Success',
								text: 'Notification has been sent successfully',
								icon: 'success',
								confirmButtonText: 'OK',
							});
							this.$emit('hide-modal');
							this.submitLoading = false;
							await this.$store.dispatch('budgetPlan/GET_LIST_DEPARTMENT');
						});
					}
				})
				.catch((error) => {
					console.error('Error sending notification:', error);
					this.$swal({
						title: 'Error',
						text: 'Failed to send notification',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					this.submitLoading = false;
				});
		},

		async getUserEmailByDepartment(departmentId) {
			const response = await this.$store.dispatch('budgetPlan/GET_USER_BY_DEPARTMENT', {
				department: departmentId,
			});

			console.log(response);
			if (response.length == 0) {
				return [];
			}
			return response?.map((item) => item.email);
		},
		submitApproveDisapprove() {
			this.$emit('approve-disapprove');
		},
	},
};
</script>

<style scoped>
.notification-content {
	/* Add your styling for the notification content here */
}
</style>
